export default "__VITE_ASSET__1efc7606__"